import { Component } from '@angular/core';

@Component({
  selector: 'app-administrator-permissions',
  templateUrl: './administrator-permissions.component.html',
})
export class AdministratorPermissionsComponent {}
